import { render } from "./LoyaltyTiers.vue?vue&type=template&id=074166f1&scoped=true"
import script from "./LoyaltyTiers.vue?vue&type=script&lang=js"
export * from "./LoyaltyTiers.vue?vue&type=script&lang=js"

import "./LoyaltyTiers.vue?vue&type=style&index=0&id=074166f1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074166f1"]])

export default __exports__